import * as signalR from "@microsoft/signalr";
import router from "@/router";
import { MessageBox } from "element-ui";
const state = {
  hubUrl: process.env.VUE_APP_BASEURL + "/videoCall",
  connection: null,
  params: {
    videoCallRoomId: "",
    customerId: "",
    token: "",
  },
};

const actions = {
  initConnection({ commit }, payload) {
    let connection = new signalR.HubConnectionBuilder()
      .withUrl(state.hubUrl, {
        transport: signalR.HttpTransportType.LongPolling,
        accessTokenFactory: () => payload.token,
      })
      .configureLogging(signalR.LogLevel.Debug)
      .build();
    commit("setParams", payload);
    commit("setConnecttion", connection);
  },
  startConnection({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.connection
        .start()
        .then(() => {
          dispatch("onReady");
          resolve(true);
        })
        .catch((error) => {
          reject(false);
          console.log("(連線錯誤)Error establishing the connection: ", error);
        });
    });
  },
  startToCommunication({ state }, payload) {
    // payload = {VideoCallRoomId,CustomerId,Token}
    state.connection.invoke("StartToCommunication", payload);
  },
  // 自定義 on 事件
  onReady({ state, dispatch, commit, getters }) {
    state.connection.on("onError", (message) => {
      console.log("Connection Error", message);
      router.replace("/error");
    });

    state.connection.on("JoinChatRoom", (data) => {
      // on JoinChatRoom
      console.log("on JoinChatRoom", data);
      commit("setClientChatRoom", data.value.clientChatRoom);
    });
    state.connection.on("CreateChatRoom", (data) => {
      // on CreateChatRoom
      commit("setClientChatRoom", data.value.clientChatRoom);
    });
    state.connection.on("RemoveLeaveRoomUser", function() {});
    state.connection.on("ReceiveHeartBeat", (data) => {});
    state.connection.on("AgentChatFinish", (data) => {});
    state.connection.on("ChatFinish", (data) => {
      // console.log("on ChatFinish", data);
      //let { msg } = data;
      dispatch("videoCallRTC/hangup", "", { root: true });
      // if (msg === "AgentLeaveRoom") {
      //   MessageBox.alert(
      //     "謝謝您，本次視訊對話已結束，專員已經關閉聊天室。",
      //     "系統",
      //     {
      //       type: "info",
      //       center: true,
      //     }
      //   );
      // }
      router.push("/videoCallEnd");
    });
    state.connection.on("agentOffline", () => {});
    state.connection.on("agentOnline", () => {});
    state.connection.on("LeaveRoom", (res) => {
      console.log("LeaveRoom", res);
    });
    // webrtc
    state.connection.on("inComingCall", (e) => {
      console.log("inComingCall", e);
    });
    state.connection.on("callResult", (e) => {
      console.log("callResult", e);
    });
    state.connection.on("receiveSignal", (data) => {
      dispatch("videoCallRTC/receiveSignal", data, { root: true });
    });
    state.connection.on("callEnded", (data) => {
      let { hangUpBy } = data;
      console.log("on callEnded:", hangUpBy);
      if (hangUpBy !== "Customer") {
        // 若為 Customer 自己發起, Customer 也須關閉 webrtc
        // 若為 Agent 發起, Customer 也須關閉 webrtc
        dispatch("videoCallRTC/hangup", null, { root: true });
      }
    });
  },
  sendSignalToAgent({ state }, payload) {
    let data = {
      ...state.params,
      signal: payload,
    };
    // console.log("sendSignalToAgent", data);
    state.connection.invoke("sendSignalToAgent", data);
  },
  hangUpByCustomer({ state }) {
    if (state.connection !== null) {
      // console.log("HangUpByCustomer", state.params);
      state.connection.invoke("HangUpByCustomer", state.params);
    }
  },
};

const mutations = {
  setParams(state, payload) {
    state.params = payload;
  },
  setConnecttion(state, connection) {
    state.connection = connection;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
